// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.substockset .right {
    width: 100%;
    /* border: 1px solid pink; */
    display: flex !important;
    flex-direction: column !important;
    align-items: flex-start !important;
    /* justify-content: space-between !important; */
    justify-content: flex-start !important;
    font-size: 16px !important;
    padding: 0px !important;
    cursor: auto;
    gap: 20px;
  }
  
  .substockset .middle {
    /* border: 1px solid rgb(207, 255, 192) !important; */
    display: flex !important;
    flex-direction: column !important;
    align-items: flex-start !important;
    justify-content: flex-start !important;
    /* justify-content: space-between !important; */
    padding: 0px !important;
    padding-right: 15px !important;
    gap: 20px;
  }
  
  .substockset .content {
    display: flex;
    /* width: 50%; */
    align-items: flex-start;
    justify-items: center;
  
    /* height: 40px; */
    /* border: 1px solid yellowgreen; */
  }
  
  .substockset .content-new {
    display: flex;
    /* width: 50%; */
    align-items: center !important;
    justify-content: center !important;
    /* width: 100%; */
    /* height: 100%; */
    /* border: 1px solid red; */
    /* margin: auto; */
  }
  
  .substockset .content-new-0 {
    display: flex;
    /* width: 50%; */
    align-items: flex-start;
    justify-items: center;
  
    /* height: 40px; */
    /* border: 1px solid yellowgreen; */
  }
  
  .substockset .newIcon {
    display: flex;
    /* width: 50%; */
    align-items: flex-start;
    justify-content: center;
  
    /* height: 40px; */
    /* border: 1px solid yellowgreen; */
  }
  
  .substockset .content-typo {
    display: flex;
    align-items: center;
    /* height: 40px; */
    font-family: karla !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    line-height: 22px !important ;
    /* border: 1px solid rgb(0, 255, 115); */
  }
  
  .substockset .content-typo-0 {
    display: flex;
    align-items: center;
    /* height: 40px; */
    font-family: karla !important;
    font-size: 22px !important;
    font-weight: 500;
    line-height: 22px !important;
    /* border: 1px solid rgb(38, 0, 255); */
  }
  
  .substockset .content .btn {
    margin-left: auto;
  }
  
  .substockset .left {
    position: relative;
    /* display: inline-block; */
    width: 100%;
  }
  .substockset .left img {
    display: block;
    /* width: 150px;
    height: 153px; */
    width: 100%;
    height: 100%;
    /* border: 1px solid rgb(98, 0, 255); */
  }
  
  .substockset .left .hoverCheck {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 24px;
    height: 24px;
    border-radius: 5px;
    display: none; /* Initially hidden */
    /* border: 1px solid red; */
    /* appearance: none; */
  }
  
  /* Show the checkbox when hovering over the parent */
  .substockset .left.hover-enabled:hover .hoverCheck {
    display: block;
  }
  
  /* Keep the checkbox visible when checked */
  .substockset .left .hoverCheck.Mui-checked {
    display: block;
  }
  
  .substockset .left button {
    position: absolute;
    bottom: 1px;
    left: 50%;
  
    transform: translateX(-50%);
    background-color: "#FFFFFF";
    color: #50c878;
    font-weight: 500;
    font-size: 18px;
    text-transform: none;
    padding: 2px;
    border-radius: 5px;
    height: 40px;
    width: 110px;
    text-align: center;
  }
  `, "",{"version":3,"sources":["webpack://./src/features/Stock/SubStocktSetProduct/components/SubStockSetProduct.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,4BAA4B;IAC5B,wBAAwB;IACxB,iCAAiC;IACjC,kCAAkC;IAClC,+CAA+C;IAC/C,sCAAsC;IACtC,0BAA0B;IAC1B,uBAAuB;IACvB,YAAY;IACZ,SAAS;EACX;;EAEA;IACE,qDAAqD;IACrD,wBAAwB;IACxB,iCAAiC;IACjC,kCAAkC;IAClC,sCAAsC;IACtC,+CAA+C;IAC/C,uBAAuB;IACvB,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,uBAAuB;IACvB,qBAAqB;;IAErB,kBAAkB;IAClB,mCAAmC;EACrC;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,8BAA8B;IAC9B,kCAAkC;IAClC,iBAAiB;IACjB,kBAAkB;IAClB,2BAA2B;IAC3B,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,uBAAuB;IACvB,qBAAqB;;IAErB,kBAAkB;IAClB,mCAAmC;EACrC;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,uBAAuB;IACvB,uBAAuB;;IAEvB,kBAAkB;IAClB,mCAAmC;EACrC;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,6BAA6B;IAC7B,0BAA0B;IAC1B,2BAA2B;IAC3B,6BAA6B;IAC7B,wCAAwC;EAC1C;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,6BAA6B;IAC7B,0BAA0B;IAC1B,gBAAgB;IAChB,4BAA4B;IAC5B,uCAAuC;EACzC;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,2BAA2B;IAC3B,WAAW;EACb;EACA;IACE,cAAc;IACd;oBACgB;IAChB,WAAW;IACX,YAAY;IACZ,uCAAuC;EACzC;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa,EAAE,qBAAqB;IACpC,2BAA2B;IAC3B,sBAAsB;EACxB;;EAEA,oDAAoD;EACpD;IACE,cAAc;EAChB;;EAEA,2CAA2C;EAC3C;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,SAAS;;IAET,2BAA2B;IAC3B,2BAA2B;IAC3B,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;EACpB","sourcesContent":[".substockset .right {\n    width: 100%;\n    /* border: 1px solid pink; */\n    display: flex !important;\n    flex-direction: column !important;\n    align-items: flex-start !important;\n    /* justify-content: space-between !important; */\n    justify-content: flex-start !important;\n    font-size: 16px !important;\n    padding: 0px !important;\n    cursor: auto;\n    gap: 20px;\n  }\n  \n  .substockset .middle {\n    /* border: 1px solid rgb(207, 255, 192) !important; */\n    display: flex !important;\n    flex-direction: column !important;\n    align-items: flex-start !important;\n    justify-content: flex-start !important;\n    /* justify-content: space-between !important; */\n    padding: 0px !important;\n    padding-right: 15px !important;\n    gap: 20px;\n  }\n  \n  .substockset .content {\n    display: flex;\n    /* width: 50%; */\n    align-items: flex-start;\n    justify-items: center;\n  \n    /* height: 40px; */\n    /* border: 1px solid yellowgreen; */\n  }\n  \n  .substockset .content-new {\n    display: flex;\n    /* width: 50%; */\n    align-items: center !important;\n    justify-content: center !important;\n    /* width: 100%; */\n    /* height: 100%; */\n    /* border: 1px solid red; */\n    /* margin: auto; */\n  }\n  \n  .substockset .content-new-0 {\n    display: flex;\n    /* width: 50%; */\n    align-items: flex-start;\n    justify-items: center;\n  \n    /* height: 40px; */\n    /* border: 1px solid yellowgreen; */\n  }\n  \n  .substockset .newIcon {\n    display: flex;\n    /* width: 50%; */\n    align-items: flex-start;\n    justify-content: center;\n  \n    /* height: 40px; */\n    /* border: 1px solid yellowgreen; */\n  }\n  \n  .substockset .content-typo {\n    display: flex;\n    align-items: center;\n    /* height: 40px; */\n    font-family: karla !important;\n    font-size: 14px !important;\n    font-weight: 400 !important;\n    line-height: 22px !important ;\n    /* border: 1px solid rgb(0, 255, 115); */\n  }\n  \n  .substockset .content-typo-0 {\n    display: flex;\n    align-items: center;\n    /* height: 40px; */\n    font-family: karla !important;\n    font-size: 22px !important;\n    font-weight: 500;\n    line-height: 22px !important;\n    /* border: 1px solid rgb(38, 0, 255); */\n  }\n  \n  .substockset .content .btn {\n    margin-left: auto;\n  }\n  \n  .substockset .left {\n    position: relative;\n    /* display: inline-block; */\n    width: 100%;\n  }\n  .substockset .left img {\n    display: block;\n    /* width: 150px;\n    height: 153px; */\n    width: 100%;\n    height: 100%;\n    /* border: 1px solid rgb(98, 0, 255); */\n  }\n  \n  .substockset .left .hoverCheck {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    width: 24px;\n    height: 24px;\n    border-radius: 5px;\n    display: none; /* Initially hidden */\n    /* border: 1px solid red; */\n    /* appearance: none; */\n  }\n  \n  /* Show the checkbox when hovering over the parent */\n  .substockset .left.hover-enabled:hover .hoverCheck {\n    display: block;\n  }\n  \n  /* Keep the checkbox visible when checked */\n  .substockset .left .hoverCheck.Mui-checked {\n    display: block;\n  }\n  \n  .substockset .left button {\n    position: absolute;\n    bottom: 1px;\n    left: 50%;\n  \n    transform: translateX(-50%);\n    background-color: \"#FFFFFF\";\n    color: #50c878;\n    font-weight: 500;\n    font-size: 18px;\n    text-transform: none;\n    padding: 2px;\n    border-radius: 5px;\n    height: 40px;\n    width: 110px;\n    text-align: center;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
